import React from "react";
import { ThemeName } from "./colors";
import { themeStyles } from "./themeStyles";

type ThemeRootProps = {
  theme: ThemeName;
  children: React.ReactNode;
};

export const ThemeRoot = ({ theme, children }: ThemeRootProps) => (
  <>
    <style>{themeStyles(theme)}</style>
    <div data-theme={theme} style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {children}
    </div>
  </>
);
